export default __webpack_public_path__ + "static/media/export.2fe991e9.svg";